"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var recipients_list_provider_1 = require("../api/recipients-list-provider");
var core_1 = require("@angular/core");
var recipient_source_model_1 = require("../../models/recipient-source.model");
var of_1 = require("rxjs/observable/of");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var root_entity_organization_users_provider_service_1 = require("../../../../../shared/services/api/root-entity-organization-users-provider.service");
var party_provider_service_1 = require("../../../../../shared/services/api/party-provider.service");
var operators_1 = require("rxjs/operators");
var zip_1 = require("rxjs/observable/zip");
var meta_knowledge_provider_service_1 = require("../../../../../shared/services/api/meta-knowledge-provider.service");
var recipient_combo_model_1 = require("../../models/recipient-combo.model");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var DefaultRecipientsListProvider = /** @class */ (function (_super) {
    __extends(DefaultRecipientsListProvider, _super);
    function DefaultRecipientsListProvider(rootEntityOrganizationUsersProviderService, partyProviderService, deService, currentLanguageProvider, kbService, metaKnowledgeProviderService) {
        var _this = _super.call(this) || this;
        _this.rootEntityOrganizationUsersProviderService = rootEntityOrganizationUsersProviderService;
        _this.partyProviderService = partyProviderService;
        _this.deService = deService;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.kbService = kbService;
        _this.metaKnowledgeProviderService = metaKnowledgeProviderService;
        return _this;
    }
    DefaultRecipientsListProvider_1 = DefaultRecipientsListProvider;
    DefaultRecipientsListProvider.prototype.getSources = function (rootCategoryId) {
        var _this = this;
        return of_1.of([]).pipe(operators_1.switchMap(function (sources) {
            sources.push(new recipient_source_model_1.RecipientSourceModel('ejustice_court_staff', DefaultRecipientsListProvider_1.COURT_STAFF, false, 'ejustice_start_type_name_or_role'));
            return _this.metaKnowledgeProviderService.getPartyDefinitions(rootCategoryId).pipe(operators_1.map(function (partyDefinision) {
                if (partyDefinision) {
                    sources.push(new recipient_source_model_1.RecipientSourceModel('ejustice_case_parties_participants_recipients', DefaultRecipientsListProvider_1.CASE_PARTIES_PARTICIPANTS, true, 'ejustice_start_type_name_or_role', 'ejustice_select_all_parties_participants'));
                }
                return sources;
            }));
        }));
    };
    DefaultRecipientsListProvider.prototype.loadRecipients = function (recipientType, rootCategoryId, rootEntityId, rootEntity) {
        var _this = this;
        var entity$ = rootEntity ? of_1.of(rootEntity) : this.deService.loadEntityByInstanceId(rootCategoryId, rootEntityId, false);
        switch (recipientType) {
            case DefaultRecipientsListProvider_1.COURT_STAFF:
                return entity$.pipe(operators_1.switchMap(function (entity) {
                    var users$ = _this.rootEntityOrganizationUsersProviderService.getUsers(rootCategoryId, rootEntityId, entity);
                    var language$ = _this.currentLanguageProvider.getCurrentLanguage();
                    return zip_1.zip(users$, language$);
                }), operators_1.map(function (_a) {
                    var users = _a[0], languageId = _a[1];
                    return _this.constructRecipientComboModelFromUsers(users, languageId.getId());
                }), operators_1.take(1));
            case DefaultRecipientsListProvider_1.CASE_PARTIES_PARTICIPANTS:
                return entity$.pipe(operators_1.switchMap(function (entity) {
                    var parties$ = _this.getParties(rootCategoryId, rootEntityId, entity);
                    var language$ = _this.currentLanguageProvider.getCurrentLanguage();
                    var partyMetaKnowledge$ = _this.metaKnowledgeProviderService.getPartyDefinitions(rootCategoryId);
                    return zip_1.zip(parties$, language$, partyMetaKnowledge$);
                }), operators_1.map(function (_a) {
                    var parties = _a[0], languageId = _a[1], partyMetaKnowledge = _a[2];
                    return _this.constructRecipientComboModelFromParties(parties, languageId.getId(), partyMetaKnowledge.partyEmailField);
                }), operators_1.take(1));
            default:
                return of_1.of([]);
        }
    };
    DefaultRecipientsListProvider.prototype.getParties = function (rootCategoryId, rootEntityId, rootEntity) {
        var _this = this;
        var partyMetaKnowledge$ = this.metaKnowledgeProviderService.getPartyDefinitions(rootCategoryId);
        return partyMetaKnowledge$.pipe(operators_1.switchMap(function (partyMetaKnowledge) {
            var parties$ = _this.partyProviderService.getParties(rootCategoryId, rootEntityId, rootEntity);
            var participants$ = _this.partyProviderService.getParticipants(rootCategoryId, rootEntityId, rootEntity);
            var advocates$ = _this.partyProviderService.getAdvocates(rootCategoryId, rootEntityId, rootEntity);
            var instanceMetaField$ = _this.kbService.getInstanceMetaField(partyMetaKnowledge.category);
            return zip_1.zip(parties$, participants$, advocates$, partyMetaKnowledge$, instanceMetaField$);
        }), operators_1.switchMap(function (_a) {
            var parties = _a[0], participants = _a[1], advocates = _a[2], metaKnowledge = _a[3], instanceMetaField = _a[4];
            var partiesIds = _this.getActivePartiesIds(parties, participants, advocates, metaKnowledge);
            var paging = new idm_de_core_frontend_1.PagingOptions(0, partiesIds.length);
            var filter = JSON.stringify(new idm_de_core_frontend_1.FilterBuilder().in(instanceMetaField.getSystemName(), partiesIds).build().toJson());
            return _this.deService.loadEntities(metaKnowledge.category, paging, "{\"condition\":" + filter + "}");
        }), operators_1.take(1));
    };
    DefaultRecipientsListProvider.prototype.getActivePartiesIds = function (parties, participants, advocates, metaKnowledge) {
        var isPartyExists = parties.length || participants.length || advocates.length;
        if (!isPartyExists) {
            return [];
        }
        parties = parties.filter(function (party) { return party.getProperty(metaKnowledge.isActiveField).value; });
        participants = participants.filter(function (party) { return party.getProperty(metaKnowledge.isActiveField).value; });
        advocates = advocates.filter(function (party) { return party.getProperty(metaKnowledge.isActiveField).value; });
        var partiesIds = new Set();
        parties.forEach(function (party) {
            partiesIds.add(party.getProperty(metaKnowledge.parties.partyField).value.getInstanceId());
        });
        participants.forEach(function (party) {
            partiesIds.add(party.getProperty(metaKnowledge.participants.participantField).value.getInstanceId());
        });
        advocates.forEach(function (party) {
            partiesIds.add(party.getProperty(metaKnowledge.advocates.advocateField).value.getInstanceId());
        });
        return Array.from(partiesIds);
    };
    DefaultRecipientsListProvider.prototype.constructRecipientComboModelFromUsers = function (users, languageId) {
        return users.map(function (user) {
            return new recipient_combo_model_1.RecipientComboModel(user.getProperty('USEREMAIL').value, user.getProperty('name').value, languageId);
        });
    };
    DefaultRecipientsListProvider.prototype.constructRecipientComboModelFromParties = function (parties, languageId, emailField) {
        return parties.getData().map(function (party) {
            return new recipient_combo_model_1.RecipientComboModel(party.getProperty(emailField).value, party.getProperty('name').value, languageId);
        });
    };
    var DefaultRecipientsListProvider_1;
    DefaultRecipientsListProvider.COURT_STAFF = 'court-staff';
    DefaultRecipientsListProvider.CASE_PARTIES_PARTICIPANTS = 'case-parties-participants';
    DefaultRecipientsListProvider = DefaultRecipientsListProvider_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [root_entity_organization_users_provider_service_1.RootEntityOrganizationUsersProviderService,
            party_provider_service_1.PartyProviderService,
            idm_de_service_client_js_1.DeService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_kb_service_client_js_1.KbService,
            meta_knowledge_provider_service_1.MetaKnowledgeProviderService])
    ], DefaultRecipientsListProvider);
    return DefaultRecipientsListProvider;
}(recipients_list_provider_1.RecipientsListProvider));
exports.DefaultRecipientsListProvider = DefaultRecipientsListProvider;
//# sourceMappingURL=default-recipients-list-provider.js.map